<template>
	<div class="grid md:grid-cols-2 gap-x-6 gap-y-6">
		<div>
			<h3 class="text-2xl font-semibold text-gray-700 mb-6">
				{{ __("price_indiciations_info_overview_title") }}
			</h3>
			<p>
				{{ __("price_indiciations_info_overview_text_1") }}
				<u
					class="cursor-pointer"
					v-on:click="
						$bus.$emit(
							'toggle-iframe-modal',
							$route('user.index', { iframe_modal: 1 })
						)
					"
					>{{ __("price_indiciations_info_overview_link") }}</u
				>. {{ __("price_indiciations_info_overview_text_2") }}
			</p>
		</div>

		<div>
			<h3 class="text-2xl font-semibold text-gray-700 mb-6">
				{{ __("price_indiciations_info_change_title") }}
			</h3>
			<p>{{ __("price_indiciations_info_change_text") }}</p>
		</div>

		<div>
			<h3 class="text-2xl font-semibold text-gray-700 mb-6">
				{{ __("price_indiciations_info_quantity_title") }}
			</h3>
			<p>{{ __("price_indiciations_info_quantity_text") }}</p>
		</div>

		<div>
			<h3 class="text-2xl font-semibold text-gray-700 mb-6">
				{{ __("price_indiciations_info_contact_title_1") }}<br />
				{{ __("price_indiciations_info_contact_title_2") }}
			</h3>
			<div class="flex gap-x-4">
				<div class="pt-2">
					<img :src="contactPersonUrl" class="h-16 w-16 rounded-full" />
				</div>
				<p>
					Maximilian von Weichs<br />
					+49 (0) 172 1011 622<br />
					m.weichs@cropspot.com
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		contactPersonUrl: () => window.baseUrl + "/images/max-rounded.jpg",
	},
};
</script>
